import NumberInputControl from './NumberInput';
import GroupControl from './GroupControl';
import TextInputControl from './TextInput';
import MapControl from './MapControl';
import StreetViewControl from './StreetViewControl';
import MediaControl from './MediaInput';
import ListControl from './ListControl';
import ChartControl from './ChartControl';
import SelectControl from './SelectControl';
import {
  V2GroupComponentDef,
  V2TextTemplateComponent,
  V2NumberTemplateComponent,
  V2MapComponent,
  V2StreetViewComponent,
  V2MediaComponent,
  V2ListComponent,
  V2ChartComponent,
  V2LinkComponent,
  V2SelectComponent,
} from '@terragotech/page-renderer';
import { PageControlProps, NestedPageControlProps } from '../PageTypes';
import LinkControl from './LinkControl';

interface PageBuilderControlMap {
  group?: React.ComponentType<PageControlProps<V2GroupComponentDef>>;
  text?: React.ComponentType<NestedPageControlProps<V2TextTemplateComponent>>;
  textinput?: React.ComponentType<NestedPageControlProps<V2TextTemplateComponent>>;
  datetime?: React.ComponentType<NestedPageControlProps<V2TextTemplateComponent>>;
  date?: React.ComponentType<NestedPageControlProps<V2TextTemplateComponent>>;
  dateinput?: React.ComponentType<NestedPageControlProps<V2TextTemplateComponent>>;
  time?: React.ComponentType<NestedPageControlProps<V2TextTemplateComponent>>;
  timeinput?: React.ComponentType<NestedPageControlProps<V2TextTemplateComponent>>;
  link?: React.ComponentType<NestedPageControlProps<V2LinkComponent>>;
  image?: React.ComponentType<NestedPageControlProps<V2MediaComponent>>;
  file?: React.ComponentType<NestedPageControlProps<V2MediaComponent>>;
  number?: React.ComponentType<NestedPageControlProps<V2NumberTemplateComponent>>;
  numberinput?: React.ComponentType<NestedPageControlProps<V2NumberTemplateComponent>>;
  aggregateMap?: React.ComponentType<NestedPageControlProps<V2MapComponent>>;
  streetView?: React.ComponentType<NestedPageControlProps<V2StreetViewComponent>>;
  list?: React.ComponentType<NestedPageControlProps<V2ListComponent>>;
  chart?: React.ComponentType<NestedPageControlProps<V2ChartComponent>>;
  select?: React.ComponentType<NestedPageControlProps<V2SelectComponent>>;
  multiselect?: React.ComponentType<NestedPageControlProps<V2SelectComponent>>;
}

export const controlMap: PageBuilderControlMap = {
  group: GroupControl,
  text: TextInputControl,
  textinput: TextInputControl,
  date: TextInputControl,
  dateinput: TextInputControl,
  time: TextInputControl,
  timeinput: TextInputControl,
  datetime: TextInputControl,
  link: LinkControl,
  image: MediaControl,
  file: MediaControl,
  number: NumberInputControl,
  numberinput: NumberInputControl,
  aggregateMap: MapControl,
  streetView: StreetViewControl,
  list: ListControl,
  chart: ChartControl,
  select: SelectControl,
  multiselect: SelectControl,
};
export { default as PageFrame } from './PageFrame';
